module.exports = __webpack_public_path__ + "static/media/main idea.c4f4fabd.mp3";